import LeaseApiService from '../../services/apiService';
import { endPoint } from '../../EndPoints/endPoint';

// Releases touch lease, sale and payment-schedule tables together server-side,
// so this one call gets a much longer timeout than the rest of the module.
const RELEASE_TIMEOUT_MS = 5 * 60 * 1000;

class UnitReleaseRAApi {
  constructor() {
    this.apiService = new LeaseApiService();
  }

  getDropdowns(dropdownTypes = ['Properties', 'ReleaseTypes']) {
    return this.apiService.post('UNIT_RELEASE_RA_DROPDOWNS', { dropdownTypes });
  }

  getSettings() {
    return this.apiService.get('UNIT_RELEASE_RA_SETTINGS');
  }

  getUnits(propertyNo, leaseReserved = false) {
    const params = new URLSearchParams();
    params.append('propertyNo', propertyNo || '');
    params.append('leaseReserved', leaseReserved ? 'true' : 'false');
    return this.apiService.getApiParamater('UNIT_RELEASE_RA_UNITS', `?${params.toString()}`);
  }

  getUnitInfo(propertyNo, unitNo, leaseReserved = false) {
    const params = new URLSearchParams();
    params.append('propertyNo', propertyNo || '');
    params.append('unitNo', unitNo || '');
    params.append('leaseReserved', leaseReserved ? 'true' : 'false');
    return this.apiService.getApiParamater('UNIT_RELEASE_RA_UNIT_INFO', `?${params.toString()}`);
  }

  getCandidates({ propertyNo, unitNo, releaseType, entireGroup = false, groupId = '', leaseReserved = false }) {
    const params = new URLSearchParams();
    params.append('propertyNo', propertyNo || '');
    params.append('unitNo', unitNo || '');
    params.append('releaseType', releaseType || '');
    params.append('entireGroup', entireGroup ? 'true' : 'false');
    params.append('groupId', groupId || '');
    params.append('leaseReserved', leaseReserved ? 'true' : 'false');
    return this.apiService.getApiParamater('UNIT_RELEASE_RA_CANDIDATES', `?${params.toString()}`);
  }

  releaseUnits(body) {
    // Bypasses LeaseApiService.post (no per-call config support) so this one
    // request can carry a longer timeout without changing the shared client.
    return this.apiService.axiosInstance.post(endPoint.UNIT_RELEASE_RA_SAVE, body, { timeout: RELEASE_TIMEOUT_MS });
  }

  getReleases(filters = {}, pageNo = 1, pageSize = 50) {
    const params = new URLSearchParams();
    params.append('propertyNo', filters.propertyNo || '');
    params.append('unitNo', filters.unitNo || '');
    params.append('resvNo', filters.resvNo || '');
    params.append('releaseType', filters.releaseType || '');
    params.append('unitClass', filters.unitClass || '');
    params.append('releasedBy', filters.releasedBy || '');
    params.append('fromDate', filters.fromDate || '');
    params.append('toDate', filters.toDate || '');
    params.append('pageNo', pageNo || 1);
    params.append('pageSize', pageSize || 50);
    return this.apiService.getApiParamater('UNIT_RELEASE_RA_LIST', `?${params.toString()}`);
  }
}

export default UnitReleaseRAApi;
